import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tooltip,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { RiUserForbidFill } from "react-icons/ri";
import { UserModel } from "../../services";
import { useState } from "react";

export default function DisableUserModal({ id, onDisable }) {
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let res = await UserModel.disable(id);
      if (res.status === 200) {
        toast({
          description: "User disabled successfully!",
          status: "success",
          isClosable: true,
        });
        onDisable(id);
        onClose();
      }
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip label="Disable User">
        <IconButton
          icon={<RiUserForbidFill />}
          bgColor="yellow.100"
          color="yellow.500"
          fontSize="xl"
          isRound
          onClick={onOpen}
        />
      </Tooltip>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Disable User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure? Disabling the user account will prevent user from
            login.
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => onClose()}
              bgColor="gray.200"
              color="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
              me="2"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={onSubmit}
              isLoading={loading}
              loadingText="sending..."
              bgColor="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
            >
              Confirm Disable
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
